export enum TrackingType {
  BATCHED = 'batch',
  CLIENT_BATCHED = 'batch-client',
  REALTIME = 'realtime',
}

declare global {
  interface Window {
    da: Function
  }
}

export const getEnvironment = (
  type: TrackingType = TrackingType.CLIENT_BATCHED
) => `production-${type}`

interface DaTrackOptions {
  schema: string
  data: any
  trackingType?: TrackingType
  environment?: string
  schemaVersion?: string
}

const isProduction = process.env.NODE_ENV === 'production'

export function trackSnowplow({
  schema,
  data,
  trackingType = TrackingType.BATCHED,
  environment = getEnvironment(trackingType),
  schemaVersion = '1-0-0',
}: DaTrackOptions) {
  if (!window.da && !isProduction) return

  window.da(`trackUnstructEvent:${environment}`, {
    schema: `iglu:com.shaadi/${schema}/jsonschema/${schemaVersion}`,
    data,
  })
}
